import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Experience from "./pages/Experience";
import Projects from "./pages/Projects";
import Skills from "./pages/Skills";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Navbar from "./components/Navbar";
import "./App.css";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <Router>
      <div className="old-crt-monitor">
        <div className="retro-container">
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/experience" element={<Experience />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/projects/archive" element={<Projects />} />
              <Route path="/skills" element={<Skills />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:id" element={<BlogPost />} />
            </Routes>
          </main>
          <footer className="pipboy-footer" aria-label="Site Footer">
            <hr className="footer-divider" />
            <div className="social-links" aria-label="Social links">
              <ul className="footer-icons-row">
                <li>
                  <a
                    className="fa-icon"
                    href="https://github.com/RachieCodes"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="GitHub"
                  >
                    <i className="fab fa-github" aria-hidden="true"></i>
                  </a>
                </li>
                <li>
                  <a
                    className="fa-icon"
                    href="https://www.linkedin.com/in/rachel-johnson-codes/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="LinkedIn"
                  >
                    <i className="fab fa-linkedin" aria-hidden="true"></i>
                  </a>
                </li>
                <li>
                  <a
                    className="fa-icon"
                    href="mailto:RachieCodes@outlook.com"
                    aria-label="Email"
                  >
                    <span className="email-icon">
                      <i className="fas fa-envelope" aria-hidden="true"></i>
                    </span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer-text">
              <p>
                © {new Date().getFullYear()} Rachie Codes.{" "}
                <span className="stay-upgraded">Stay upgraded.</span>
              </p>
            </div>
          </footer>
        </div>
      </div>
    </Router>
  </React.StrictMode>
);